import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App';
import './utils/i18n';
import { RouterProviderWithAuth } from './routes/Router';
import { SWRConfig } from 'swr'
import { SWRConfigOptions } from './services/SWRConfigOption';
import { AuthProvider } from './contexts/AuthContext';
import { DataTableDemo } from './components/data-table-demo';
import { Toaster } from './components/ui/sonner';
import * as Sentry from "@sentry/react";
import { GamificationProvider } from './contexts/GamificationContext';
import DisableDevtool from 'disable-devtool';

// Import mathlive and configure globally
// NOTE: MathLive version is pinned to 0.104.2 to avoid ariaLiveText bug in 0.105.x
// See: https://github.com/arnog/mathlive/issues/2906
// The bug causes: "undefined is not an object (evaluating 'this.ariaLiveText.textContent=""')"
import { MathfieldElement } from "mathlive";
import "mathlive/fonts.css";

if (import.meta.env.PROD) {
  DisableDevtool();
}

// Configure MathfieldElement globally
MathfieldElement.soundsDirectory = null;
MathfieldElement.keypressVibration = false;
// Don't set fontsDirectory to null - let mathlive use default font loading

if (import.meta.env.PROD) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

if (!import.meta.env.DEV && !Sentry.isInitialized()) {
  Sentry.init({
    dsn: "https://915a2bae4cd55dc1891cd6dc5715435a@o427097.ingest.us.sentry.io/4509624572116992",
    integrations: [
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        autoInject: false,
        colorScheme: "light",
        enableScreenshot: true,
        showName: false,
        showEmail: false,
        showBranding: false,
        triggerLabel: 'Feedback',
      }),
    ],
  });
}

createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an Error Boundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an Error Boundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <SWRConfig value={SWRConfigOptions}>
      <AuthProvider>
        <GamificationProvider>
          <RouterProviderWithAuth/>
          <Toaster position='top-center'></Toaster>
        </GamificationProvider>
      </AuthProvider>
    </SWRConfig>
  </StrictMode>,
)
